export default {
  MENU_TITLE: "Transferts d'équipements",
  STATUS_DRAFT: "Brouillon",
  STATUS_SUBMITTED: "Soumis",
  STATUS_ACCEPTED: "Accepté",
  STATUS_REJECTED: "Rejeté",
  STATUS_CANCELED: "Annulé",
  STATUS_PARTIALLY_RETURNED: "Partiellement retourné",
  STATUS_RETURNED: "Retourné",
  TYPE_TEMPORARY: "Temporaire",
  TYPE_PERMANENT: "Permanent",
  TRANSFER_TYPE: "Type de transfert",
  TRANSFER_DATE: "Date du transfert",
  RETURN_DATE: "Date de retour",
  RETURN: "Retourner",
  RETURN_ALL: "Tout retourner",
  RETURNED_AT: "Retourné le",
  RETURNED_BY: "Retourné par",
  ON_LOAN: "En prêt",
  AVAILABLE: "Disponible",
  LOAN_STATUS: "Statut de prêt",
  LOANED_TO: "En prêt chez",
  OVERDUE_RETURN: "Retour en retard",
  OVERDUE_RETURNS_TITLE: "Retours d'équipements en retard",
  TO_VALIDATE_TITLE: "Transferts d'équipements à valider",
  EQUIPMENT: "Équipement",
  EQUIPMENTS: "Équipements",
  SELECT_EQUIPMENT: "Sélectionner un équipement",
  ADD_EQUIPMENT_TRANSFER: "Ajouter un transfert d'équipement",
  EDIT_EQUIPMENT_TRANSFER: "Modifier un transfert d'équipement",
  DELETE_EQUIPMENT_TRANSFER: "Supprimer le transfert d'équipement",
  ADD_ITEMS_FIRST: "Ajoutez au moins un équipement avant de soumettre.",
  INCLUDE: "Inclure",
  NO_AVAILABLE_EQUIPMENT: "Aucun équipement disponible pour cet établissement.",
  SELECTED_COUNT: "{count} équipement(s) sélectionné(s)",
  EQUIPMENT_ALREADY_ON_LOAN: "Cet équipement est déjà en prêt.",
  SUBMITTED_BY: "Soumis par",
  SUBMITTED_AT: "Soumis le",
  ACCEPTED_BY: "Accepté par",
  ACCEPTED_AT: "Accepté le",
  SOURCE_ESTABLISHMENT: "Établissement source",
  DESTINATION_ESTABLISHMENT: "Établissement destination",
  CURRENTLY_TRANSFERRED: "Actuellement transféré",
  SERIAL_NUMBER: "Numéro de série",
  BRAND: "Marque",
  QUANTITY: "Quantité",
  ACCEPT: "Accepter",
  REJECT: "Rejeter",
  REVERT_TO_DRAFT: "Remettre en brouillon",
  SOURCE_DESTINATION_MUST_DIFFER:
    "L'établissement source et l'établissement destination doivent être différents.",
  RETURN_DATE_REQUIRED:
    "La date de retour est requise pour un transfert temporaire.",
  SUBMIT: "Valider et soumettre",
  SUBMIT_QUESTION:
    "Soumettre le transfert d'équipement à l'établissement destinataire ?",
  EQUIPMENT_TRANSFER_SUBMITTED: "Transfert d'équipement soumis",
  ACCEPT_QUESTION: "Accepter ce transfert d'équipement ?",
  EQUIPMENT_TRANSFER_ACCEPTED: "Transfert d'équipement accepté",
  REJECT_QUESTION: "Rejeter ce transfert d'équipement ?",
  EQUIPMENT_TRANSFER_REJECTED: "Transfert d'équipement rejeté",
  CANCEL_QUESTION: "Annuler ce transfert d'équipement ?",
  EQUIPMENT_TRANSFER_CANCELED: "Transfert d'équipement annulé",
  REVERT_TO_DRAFT_QUESTION: "Remettre le transfert d'équipement en brouillon ?",
  EQUIPMENT_TRANSFER_REVERTED: "Transfert d'équipement remis en brouillon",
  RETURN_ALL_QUESTION:
    "Confirmer le retour de tous les équipements de ce transfert ?",
  EQUIPMENT_TRANSFER_RETURNED: "Équipements retournés",
  EQUIPMENT_ITEM_RETURNED: "Équipement retourné",
  SUBMITTER_CANNOT_DECIDE:
    "Vous avez créé ou soumis ce transfert : son acceptation ou son rejet revient à l'établissement destinataire.",
  ONLY_AUTHOR_CAN_REVERT:
    "Seul le créateur du transfert peut le remettre en brouillon.",
  SEND_BY_MAIL: "Envoyer par courriel",
  SEND_NOW_QUESTION: "Envoyer le transfert d'équipement maintenant ?",
  SEND_NOW_HINT:
    "Vous pouvez envoyer le transfert à l'établissement destinataire dès maintenant pour éviter les oublis.",
  MAIL_SENT_AT: "Envoyé le",
  MAIL_SENT_BY: "Envoyé par",
  VIEW_TRANSFER: "Consulter le transfert",
};
